import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=75b6e0e7&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Risk.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Risk.vue?vue&type=style&index=0&id=75b6e0e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b6e0e7",
  null
  
)

export default component.exports